<tt-page *ngIf="page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="bspsetup_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="buttons"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!page">
        <tt-select *ngIf="page.bsp_keyno_today === '0'" ttLabel="bsp_keyno" [(ttModel)]="page.bsp_keyno" [ttData]="bsps" ttDataId="bsp_keyno" ttDataName="bsp_name"></tt-select>
        <tt-textarea ttLabel="infotext" [ttModel]="page.infotext" ttReadonly></tt-textarea>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!page">
        <tt-button-save *ngIf="page.show_execute_setup === '1'" ttText="bspsetup_execute" (ttClick)="executeChanges()" [ttLoading]="executing"></tt-button-save>
        <tt-button *ngIf="page.show_rollback_setup === '1'" ttText="bspsetup_rollback" (ttClick)="rollbackValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="rollbacking"></tt-button>
        <tt-button *ngIf="page.show_bspsetup_reset_usergroups === '1'" ttText="bspsetup_reset_usergroups" (ttClick)="resetValues()" ttIcon="fas fa-exclamation-triangle" ttType="danger" [ttLoading]="resetting"></tt-button>
        <tt-button *ngIf="page.show_bspsetup_nulldata === '1'" ttText="bspsetup_nulldata" (ttClick)="nullDataValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="nulling"></tt-button>
        <tt-button *ngIf="page.show_bspsetup_nulldata_transactiondata === '1'" ttText="bspsetup_nulldata_transactiondata" [ttLoading]="resettingData" (ttClick)="resetDataChanges()" ttType="danger" ttIcon="fas fa-sync-alt" ttIconAlign="right" ttTextAlign="center"></tt-button>
        <tt-button-goto ttText="p2_m_mietables" ttGoto="mietables"></tt-button-goto>
        <tt-button-goto ttText="bspsetup_defaultcounters" ttGoto="defaultcounters"></tt-button-goto>
    </ng-container>
</ng-template>
